export default "__VITE_ASSET__DXl7vrZt__"